<template>
    <div>

        <div class="row">

            <div class="col-md-6">
                <map-card
                    :title="'Water infrastructure: ' + typeCapitalized"
                    :config="mapConfig">

                    <template slot="body">
                        <spatial-searcher
                            :target-slug="type"
                            @search="search"
                        ></spatial-searcher>
                    </template>

                </map-card>

            </div>

            <div class="col-md-6">
                <water-sources-table
                    :button-url="currentUrl"
                    :water-sources="filteredUnits"
                    @foundItems="(items) => { filteredItems = items }" >
                </water-sources-table>
            </div>

        </div>

    </div>
</template>

<script>

import MapAndTable from "../mixins/MapAndTable";

import WaterSourcesTable from '../water-source/WaterSourcesTable';

import VectorLayer from 'ol/layer/vector';
import VectorSource from 'ol/source/vector';

import mapUtils from '../../src/maps/utils';

import SpatialSearcher from '../filters/AdminUnitSpatialSearcher';

export default {

    mixins : [MapAndTable],

    components: {
        "water-sources-table": WaterSourcesTable,
        "spatial-searcher": SpatialSearcher
    },

    props: {

        geoJson: {
            type: Object,
            required: true
        }

    },

    data(){
        return {

            unitsOlLayer: new VectorLayer({
                name: this.type,
                style: mapUtils.pointStyle
            }),

            searchUnitsOlLayer: new VectorLayer({
                name: `${this.type}_search`,
                style: mapUtils.searchedPointStyle,
                source: new VectorSource()
            }),

            filteredUnits: this.units,

        };
    },

    mounted(){
        this.initBasicMapLayer(this.geoJson);
    },

    methods: {

        search(items) 
        {
            this.filteredUnits = items;
        }
    }

};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/water-source/WaterSourcesIndex.vue